import Api from '@/services/Api';
//import Sapi from '@/services/Sapi';
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
//import xmlformcontent from './modules/xmlformcontent.js';

let parser = require('xml-js');
Vue.use(Vuex)
Vue.use(VueAxios, axios)

var quizstarURL = process.env.VUE_APP_BASEAPI;
//var adserverapiURL ="http://local.adserver.com/api/v2/xmlrpc/";
var adserverapiURL = process.env.VUE_APP_ADSERVER_APP_BASEAPI; // "http://local.adserver.com/www/api/rest_v1/rest.php?rest=/";
var adserverCampaignsId = process.env.VUE_APP_ADSERVER_CAMPAIGNSID; // "http://local.adserver.com/www/api/rest_v1/rest.php?rest=/";



export default{
  register(context, data) {
    return new Promise((resolve, reject) => {
      Api.post('register', {
        firstname: data.firstname,
        lastname: data.lastname,
        email: data.email,
        password: data.password,
        region: data.region,
        username: data.username,
        dob : data.dob,
        gender : data.gender,
        cityname : data.cityname,
        suburb : data.suburb,
        stateid : data.stateid
      }).then(response => {
        const token = response.data.access_token;
        const damntoken = token;// response.data.dammn_response.access_token;
        localStorage.setItem('damn_token', damntoken);
        localStorage.setItem('access_token', token);
        context.commit('retrieveToken', token);
        context.commit('retrieveDamnToken', damntoken);

        resolve(response);
      }).catch(error => {
        reject(error);
      })
    })
  },
  destroyToken(context) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        Api.post('logout').then(response => {
          localStorage.removeItem('access_token');
          context.commit('destroyToken');
          resolve(response);
        }).catch(error => {
          localStorage.removeItem('access_token');
          context.commit('destroyToken');
          reject(error);
        })
      })
    }
  },
  retrieveToken(context, credentials) {
    return new Promise((resolve, reject) => {
      Api.post('login', {
        username: credentials.username,
        password: credentials.password,
        damnnId: credentials.DamnnId,
      }).then(response => {
        const token = response.data.access_token;
        const damntoken = token;// response.data.dammn_response.access_token;
        localStorage.setItem('damn_token', damntoken);
        localStorage.setItem('access_token', token);
        context.commit('retrieveToken', token);
        context.commit('retrieveDamnToken', damntoken);
        resolve(response);
      }).catch(error => {
        reject(error);
      })
    })
  },
  retrieveUserDetails(context) {
  //  axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        Api.get('user').then(response => {
          const name    = response.data.data.firstname;
          const email   = response.data.data.email;
          const isAdmin = response.data.data.role == 'admin' ? true : false
          const paypal  = response.data.data.paypal_payer_id;
          const userid  = response.data.data.id;
          
          context.commit('setName', name);
          context.commit('setUserid',userid);
          context.commit('setEmail', email);
          context.commit('setIsAdmin', isAdmin);
          context.commit('setPaypal',paypal);

           var today = new Date();
          //  var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
           // var time = today.getHours() + ":" + today.getMinutes() + ":" + 
            today.getSeconds();
          context.commit('setAvatar',response.data.data.avatar);
          context.commit('setFirstName', response.data.data.firstname);
          context.commit('setLastName', response.data.data.lastname);
          context.commit('setRegion', response.data.data.region);

          context.commit('setUsername', response.data.data.username);
          context.commit('setDob', response.data.data.dob);
          context.commit('setGender', response.data.data.gender);

          context.commit('setStateid', response.data.data.stateid);
          context.commit('setCityname', response.data.data.cityname);
          context.commit('setSuburb', response.data.data.suburb);

          
          
          resolve(response);
        }).catch(error => {
          context.commit('setName', '');
          context.commit('setEmail', '');
          context.commit('setIsAdmin', false);
          reject(error);
        })
      })
    }
  },
  retrieveScores(context) {
   // axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        Api.get('score/all').then(response => {
          const scores = response.data.data;
          context.commit('setScores', scores);
          resolve(response.data);
        }).catch(error => {
          context.commit('setScores');
          reject(error);
        })
      })
    }
  },
  retrieveBalance(context) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        Api.get('bank/balance').then(response => {
          const balance = response.data.data.balance;
          context.commit('setBalance', balance);
          resolve(response.data);
        }).catch(error => {
          context.commit('setBalance');
          reject(error);
        })
      })
    }
  },
  retrieveRates(context) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        Api.get('rates').then(response => {
          const rates = response.data.data;
          context.commit('setRates', rates);
          resolve(response.data);
        }).catch(error => {
          context.commit('setRates');
          reject(error);
        })
      })
    }
  },
  retrieveGiftPayBalance(context) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        Api.get('rewards/admin/balance/all').then(response => {
          const giftPayBalance = response.data.data;
          context.commit('setGiftPayBalance', giftPayBalance);
          resolve(response.data);
        }).catch(error => {
          context.commit('setGiftPayBalance');
          reject(error);
        })
      })
    }
  },
  retrieveTransactions(context) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        Api.get('bank/transactions').then(response => {
          const transactions = response.data.data;
          context.commit('setTransactions', transactions);
          resolve(response.data);
        }).catch(error => {
          context.commit('setTransactions');
          reject(error);
        })
      })
    }
  },
  retrieveAdminTransactions(context) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        Api.get('bank/admin/transactions').then(response => {
          const adminTransactions = response.data.data;
          context.commit('setAdminTransactions', adminTransactions);
          resolve(response.data);
        }).catch(error => {
          context.commit('setAdminTransactions');
          reject(error);
        })
      })
    }
  },
  retrieveAdminGameTransactions(context) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        Api.get('game/admin/transactions').then(response => {
          const adminGameTransactions = response.data.data;
          context.commit('setAdminGameTransactions', adminGameTransactions);
          resolve(response.data);
        }).catch(error => {
          context.commit('setAdminGameTransactions');
          reject(error);
        })
      })
    }
  },
  retrieveRewards(context) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        Api.get('rewards').then(response => {
          const rewards = response.data.data;
          context.commit('setRewards', rewards);
          resolve(response.data);
        }).catch(error => {
          context.commit('setRewards');
          reject(error);
        })
      })
    }
  },
  retrieveAdminRewards(context) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        Api.get('rewards/admin').then(response => {
          const adminRewards= response.data.data;
          context.commit('setAdminRewards', adminRewards);
          resolve(response.data);
        }).catch(error => {
          context.commit('setAdminRewards');
          reject(error);
        })
      })
    }
  },
  retrieveAdminFeatures(context) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        Api.get('features').then(response => {
          const features= response.data.data;
          context.commit('setAdminFeatures', features);
          resolve(response.data);
        }).catch(error => {
          context.commit('setAdminFeatures');
          reject(error);
        })
      })
    }
  },
  retrievePaymentMethods(context) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        Api.get('bank/stripe/payment_methods').then(response => {
          const paymentMethods= response.data.data;
          context.commit('setPaymentMethods', paymentMethods);
          resolve(response.data);
        }).catch(error => {
          context.commit('setPaymentMethods');
          reject(error);
        })
      })
    }
  },
  retrievePaymentAmounts(context) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        Api.get('bank/stripe/valid_payment_amounts').then(response => {
          const paymentAmounts= response.data.data;
          context.commit('setPaymentAmounts', paymentAmounts);
          resolve(response.data);
        }).catch(error => {
          context.commit('setPaymentAmounts');
          reject(error);
        })
      })
    }
  },
  getdisableQuestionsList(context){
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        Api.get('last200').then(response => {
          resolve(response.data);
        }).catch(error => {
          reject(error);
        })
      })
    }  
  },
  getQuestionsList(context,data){
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        Api.get('questionlist?'+data.paramters).then(response => {
          resolve(response.data);
        }).catch(error => {
          reject(error);
        })
      })
    }
  },  
  updateQuestionStatus(context,data){
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        var difficulty = data.difficulty ? data.difficulty : '';
        Api.post('updatequestion/'+data.id,
         {
             "difficulty": difficulty
         }).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        })
      })
    } 
  },
  updateQuestion(context,data){
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        var difficulty = data.difficulty ? data.difficulty : '';
        Api.post('updatequestion/'+data.id,
          {
             "question":data.question,
             "option_a":data.optiona,
             "option_b":data.optionb,
             "option_c":data.optionc,
             "option_d":data.optiond,
             "correct_answer":data.answer,
             "difficulty": difficulty
         }).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        })
      })
    } 
  },
  getQuestionCategories(context){
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        Api.get('categorylist').then(response => {
          resolve(response.data);
        }).catch(error => {
          reject(error);
        })
      })
    }
  },
  unableQuestion(context,data){
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
    if (context.getters.loggedIn) {
      
      return new Promise((resolve, reject) => {
        Api.post('unablequestions',
          {
             "data": data.data
          }).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        })
      })
    } 
  },
  retrieveInbankKelBalance(context) {
    const damntoken =  context.state.damntoken;
    
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        Api.get(quizstarURL+'bank/inbank?app_type=quizstar',
        {
          headers: {
            'Authorization': 'Bearer ' + damntoken 
          }
        }
        ).then(response => {
          const inbankbalance = response.data.data.balance;
          const kelsbalance = response.data.data.kels;
          console.log(kelsbalance);
          context.commit('setShowamount',inbankbalance);
          context.commit('setShowkelamount', kelsbalance);
          resolve(response.data);
        }).catch(error => {
          context.commit('setShowamount');
          reject(error);
        })
      })
    }
  }, 
  retrieveDammnbankBalance(context) {
    //axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
    const damntoken =  context.state.damntoken;
   
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        Api.get(quizstarURL+'bank/dammnbank?app_type=quizstar',
        {
          headers: {
            'Authorization': 'Bearer ' + damntoken 
          }
        }
        ).then(response => {
          const dammnbankbalance = response.data.data.balance;
          context.dispatch("getCreditBalance");
          context.commit('setShowdaminamount',dammnbankbalance);
          resolve(response.data);
        }).catch(error => {
          context.commit('setShowdaminamount');
          reject(error);
        })
      })
    }
  },
  //******************   Adserver API */
  retrieveAdserverSessionid(context) {
    // let getpass = this.xmlformcontent.getFormRequestContent('oxlogon');
    // console.log(getpass);
    let passdata ='<?xml version="1.0"?><methodCall><methodName>ox.logon</methodName><params><param><value><string>admin</string></value></param><param><value><string>123456</string></value></param></params></methodCall>';
  Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        Vue.axios.post(adserverapiURL,passdata
        ).then(response => {
         var xml_response = JSON.parse(parser.xml2json(response.data, {compact: true, spaces: 1}));
       //   console.log(xml_response.methodResponse.params.param.value.string._text);
          var adserversessionid = xml_response.methodResponse.params.param.value.string._text;
          context.commit('setadserverSessionId',adserversessionid);
          resolve(response.data);
        }).catch(error => {
          
          reject(error);
        })
      })
    }
  },
  retrieveAdserverWebsitesListOld(context) {
    var adserversessionid =  context.state.adserversessionid;
    var AgencyId = 1;
    console.log(adserversessionid);
    let passdata ='<?xml version="1.0"?><methodCall><methodName>ox.getPublisherListByAgencyId</methodName><params><param><value><string>'+adserversessionid+'</string></value></param>   <param><value><int>'+AgencyId+'</int></value></param></params></methodCall>';
  Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        Vue.axios.post(adserverapiURL,passdata
        ).then(response => {
         var xml_response = JSON.parse(parser.xml2json(response.data, {compact: true, spaces: 1}));
       
         //console.log(xml_response.methodResponse);
         //console.log(xml_response.methodResponse.fault.value.struct.member[1].value.string._text);
       //   console.log(xml_response.methodResponse.params.param.value.array.data);
         // console.log(xml_response.methodResponse.params.param.value.array.data);
          for(var item of xml_response.methodResponse.params.param.value){
            console.log(item);
         }
          resolve(response.data);
        }).catch(error => {
          
          reject(error);
        })
      })
    }
  },
  retrieveAdserverWebsitesList() {
  //Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '';
   // if (context.getters.loggedIn) {
    
      return new Promise((resolve, reject) => {
        Vue.axios.get(adserverapiURL+"pub/agc/"+adserverCampaignsId
        ).then(response => {
        
          //  console.log(response);
        
          resolve(response.data);
        }).catch(error => {
          
          reject(error);
        })
      })
   /// }
  },
  retrieveWebsiteZoneList(context,data) {
    //Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          var websiteid = data.websiteid;
          Vue.axios.get(adserverapiURL+"zon/pub/"+websiteid).then(response => {
                       //console.log(response.data);
            resolve(response);
          }).catch(error => {
            
            reject(error);
          })
        })
      }
    },
    adserveraddbanner(context,data) {
    //  Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    var formData = data;
     if (context.getters.loggedIn) {
          return new Promise((resolve, reject) => {
            Vue.axios.post(adserverapiURL+"bnn/new",formData,{ headers: {'Content-Type': 'multipart/form-data' }}).then(response => {
               // console.log(response.data);
              resolve(response.data);
            }).catch(error => {
            reject(error);
            })
          })
        }
      },
      adservereditbanner(context,data) {
        //  Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
        var formData = data;
        var getbannerid = data.get("bannerId");
        console.log(getbannerid);
         if (context.getters.loggedIn) {
              return new Promise((resolve, reject) => {
                Vue.axios.post(adserverapiURL+"bnn/"+getbannerid,formData,{ headers: {'Content-Type': 'multipart/form-data' }}).then(response => {
                   // console.log(response.data);
                  resolve(response.data);
                }).catch(error => {
                reject(error);
                })
              })
            }
          },
          adserverdeletebanner(context,data) {
            //  Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
            var formData = data;
            var getbannerid = data.get("bannerid");
            
             if (context.getters.loggedIn) {
                  return new Promise((resolve, reject) => {
                    Vue.axios.post(adserverapiURL+"bnn/delete/"+getbannerid,formData
                    ).then(response => {
                        console.log(response);
                      resolve(response.data);
                    }).catch(error => {
                    reject(error);
                    })
                  })
                }
              },  
      adserverlinkbannerzone(context,data) {
        //  Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
        const postdata = {
          rest : "/zon"+data.zoneid+"/ban/"+data.bannerid,
        };

         if (context.getters.loggedIn) {
              return new Promise((resolve, reject) => {
                Vue.axios.post(adserverapiURL+"zon/"+data.zoneid+"/ban/"+data.bannerid,postdata,
                { headers: {'Content-Type': 'multipart/form-data' }}).then(response => {
                    console.log(response.data);
                  resolve(response.data);
                }).catch(error => {
                reject(error);
                })
              })
            }
          },
          adserverbannerstats(context,data) {
            //  Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
            if (context.getters.loggedIn) {
              return new Promise((resolve, reject) => {
                var bannerid = data.bannerid;
                var fromdate = data.fromdate;
                var todate = data.todate;
                var bannerviewby = data.bannerviewby;
                Vue.axios.get(adserverapiURL+"bnn/"+bannerid+"/statistics/"+bannerviewby+"/"+fromdate+"/"+todate).then(response => {
                  console.log(bannerviewby);
                  if(bannerviewby == "daily")
                  {
                    resolve(response.data.days); 
                    console.log(response.data.days);
                  }else
                  {
                    resolve(response.data.hours);
                  }
                  
                }).catch(error => {
                  
                  reject(error);
                })
              })
            }
              },
        retrieveAdserverWebsitesStats(context,data) {
                //  Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                var formData = new FormData();
                formData.append('bannerids',data.bannerids);
                formData.append('fromdate',data.fromdate);
                formData.append('todate',data.todate);

                if (context.getters.loggedIn) {
                  return new Promise((resolve, reject) => {
                    Vue.axios.post(adserverapiURL+"pub/statistics/websitedaily",
                    formData,{ headers: {'Content-Type': 'multipart/form-data' }}
                    ).then(response => {
                    //console.log(response.data);  
                    resolve(response.data);
                    }).catch(error => {
                      
                      reject(error);
                    })
                  })
                }
                  }, 
      bannerstatus(context,data){
        const damntoken =  context.state.token;
        
            if (context.getters.loggedIn) {
              return new Promise((resolve, reject) => 
                {
                  
                Vue.axios.post(quizstarURL+"bannerstatus",{bannerid:data.bannerid,bannerstatus:data.bannerstatus},{ 
                  headers: { 'Authorization': 'Bearer ' + damntoken  
                }}).then(response => {
                    console.log(response.data);
                  resolve(response.data);
                }).catch(error => {
                reject(error);
                })
              })
            }
      },
      quizstaraddbanner(context,data) {
        const damntoken =  context.state.token;
        //  Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
        var formData = data;
            if (context.getters.loggedIn) {
              return new Promise((resolve, reject) => {
                Vue.axios.post(quizstarURL+"saveadbanner",formData,{ 
                  headers: {'Content-Type': 'multipart/form-data',
                  'Authorization': 'Bearer ' + damntoken  
                }}).then(response => {
                    console.log(response.data);
                  resolve(response.data);
                }).catch(error => {
                reject(error);
                })
              })
            }
          },
          quizstarbannerdetails(context,data) {
            const damntoken =  context.state.token;
            //  Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                if (context.getters.loggedIn) {
                  return new Promise((resolve, reject) => {
                    Vue.axios.post(quizstarURL+"bannerdetail",{
                      bannerid : data.bannerid
                    },{ 
                      headers: {'Authorization': 'Bearer ' + damntoken  
                    }}).then(response => {
                        console.log(response.data);
                      resolve(response.data);
                    }).catch(error => {
                    reject(error);
                    })
                  })
                }
              },   
      quizstarbannerlist(context,data) {
        const damntoken =  context.state.token;
        //  Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
            if (context.getters.loggedIn) {
              return new Promise((resolve, reject) => {
                Vue.axios.post(quizstarURL+"adbannerlist"
                ,{
                  websiteid:data.websiteid,
                  adtype:data.adtype,
                  fromdate:data.fromdate,
                  todate:data.todate 
                }
                ,{ 
                  headers: {'Authorization': 'Bearer ' + damntoken  
                }}).then(response => {
                
                  context.commit('setQuizStarBannerList',response.data.data);
                   // console.log(response.data);
                  resolve(response.data);
                }).catch(error => {
                reject(error);
                })
              })
            }
          },
          quizstaradplacements(context) {
            const damntoken =  context.state.token;
            //  Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                if (context.getters.loggedIn) {
                  return new Promise((resolve, reject) => {
                    Vue.axios.get(quizstarURL+"adplacementslist",{ 
                      headers: {
                      'Authorization': 'Bearer ' + damntoken  
                    }}).then(response => {
                        //console.log(response.data);
                      resolve(response.data);
                    }).catch(error => {
                    reject(error);
                    })
                  })
                }
              },
          quizstarwebsitebannerlist(context,data) {
            const damntoken =  context.state.token;
            //  Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                if (context.getters.loggedIn) {
                  return new Promise((resolve, reject) => {
                    Vue.axios.post(quizstarURL+"adwebsitebannerlist"
                    ,{
                      websiteid:data.websiteid,
                    }
                    ,{ 
                      headers: {'Authorization': 'Bearer ' + damntoken  
                    }}).then(response => {
                      resolve(response.data);
                    }).catch(error => {
                    reject(error);
                    })
                  })
                }
              }, 
              quizstardashboardsearchbannerlist(context,data) {
                const damntoken =  context.state.token;
                //  Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                    if (context.getters.loggedIn) {
                      return new Promise((resolve, reject) => {
                        Vue.axios.post(quizstarURL+"addashboardsearchbannerlist"
                        ,{
                          websiteid:data.websiteid,
                          bannerid:data.bannerid,
                          fromdate:data.fromdate,
                          todate:data.todate 
                        }
                        ,{ 
                          headers: {'Authorization': 'Bearer ' + damntoken  
                        }}).then(response => {
                          resolve(response.data);
                        }).catch(error => {
                        reject(error);
                        })
                      })
                    }
                  },    
          quizstardeletebanner(context,data) {
            const damntoken =  context.state.token;
            //  Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                if (context.getters.loggedIn) {
                  return new Promise((resolve, reject) => {
                    Vue.axios.post(quizstarURL+"deleteadbanner",data,{ 
                      headers: {'Authorization': 'Bearer ' + damntoken  
                    }}).then(response => {
                      // console.log(response.data);
                      resolve(response.data);
                    }).catch(error => {
                    reject(error);
                    })
                  })
                }
              }, 
              damnnbankcountrieslist(context) {
                const damntoken =  context.state.token;
                //  Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                    if (context.getters.loggedIn) {
                      return new Promise((resolve, reject) => {
                        Vue.axios.get(quizstarURL+"getcountrieslist",{ 
                          headers: {
                          'Authorization': 'Bearer ' + damntoken  
                        }}).then(response => {
                            //console.log(response.data);
                          resolve(response.data);
                        }).catch(error => {
                        reject(error);
                        })
                      })
                    }
                  },
      editprofile(context, data) {
        Api.defaults.headers.common['Content-Type'] = 'multipart/form-data';
        return new Promise((resolve, reject) => {
          Api.post('editprofile',data,{ headers: {'Content-Type': 'multipart/form-data' }}).then(response => {
           //console.log(response.data.data);
           localStorage.setItem('response_status', response.data.status);
           localStorage.setItem('response_message', response.data.message);
           //context.commit('seteditProfileMessage', response.data);
            resolve(response);
          }).catch(error => {
            reject(error);
          })
        })
      },
      retrieveAdserveruserbanneridsList() {
        Api.defaults.headers.common['Content-Type'] = 'multipart/form-data';
        return new Promise((resolve, reject) => {
          Api.post('userbannerids',{ headers: {'Content-Type': 'multipart/form-data' }}).then(response => {
            resolve(response);
          }).catch(error => {
            reject(error);
          })
        })
      },
      updateTransaction(context, data){
        const damntoken =  context.state.token;
      
        const postdata = {
          transactionid: data.transactionid,
          bannerid:data.bannerid,
          }; 

          return new Promise((resolve, reject) => {
            Vue.axios.post(quizstarURL+'updateTransaction',postdata, {
              headers: {
                'Authorization': 'Bearer ' + damntoken 
              }
             }).then(response => {
              resolve(response.data);
              //resolve(response);
            }).catch(error => {
              reject(error);
            })
          })
      },
      getCreditBalance(context){
        const damntoken =  context.state.token;
        return new Promise((resolve, reject) => {
          Vue.axios.get(quizstarURL+'credit-balance', {
            headers: {
              'Authorization': 'Bearer ' + damntoken 
            }
           }).then(response => {
            const creditbalance = response.data.balance;
            context.commit('setCreditBalance', creditbalance);
            resolve(response.data);
            //resolve(response);
          }).catch(error => {
            reject(error);
          })
        })
      },
      debitBalance(context, data) {
        const damntoken =  context.state.token;
      
        const postdata = {
          amount: data.amount,
          type: data.type,
          reason: data.reason,
          app_type:"adserver"
          }; 
        return new Promise((resolve, reject) => {
          Vue.axios.post(quizstarURL+'bank/debit',postdata, {
            headers: {
              'Authorization': 'Bearer ' + damntoken 
            }
           }).then(response => {
            const inbankbalance = response.data.data.balance;
            const kelsbalance = response.data.data.kels;
            context.commit('setShowamount',inbankbalance);
            context.commit('setShowkelamount', kelsbalance);
            resolve(response.data);
            //resolve(response);
          }).catch(error => {
            reject(error);
          })
        })
      },
      adserverbannercode(context,data) {
            //  Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
            const postdata = {
              rest : "/zon/"+data.zoneid+"/ic",
              code_type: data.bannercodetype
            };
    
             if (context.getters.loggedIn) {
                  return new Promise((resolve, reject) => {
                    Vue.axios.post(adserverapiURL+"zon/"+data.zoneid+"/ic/&code_type="+data.bannercodetype,postdata,
                    { headers: {'Content-Type': 'multipart/form-data' }}).then(response => {
                        console.log(response.data);
                      resolve(response.data);
                    }).catch(error => {
                    reject(error);
                    })
                  })
                }
              },
               adserverbannertargettingold(context,data) {
                //  Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                var formData = new FormData();
                formData.append('logical',data.targetcode.logical);
               formData.append('type',data.targetcode.type);
               formData.append('data',data.targetcode.data);
               formData.append('comparison',data.targetcode.comparison);
             // var delievrycode =[];
          
                 if (context.getters.loggedIn) {
                      return  new  Promise((resolve, reject) => {
                        Vue.axios.post(adserverapiURL+"bnn/"+data.bannerid+"/targeting",formData,
                        { headers: {'Content-Type': 'multipart/form-data' }}).then(response => {
                            console.log(response.data);
                          resolve(response.data);
                        }).catch(error => {
                        reject(error);
                        })
                      })
                    }
                  },       
                   
                  async adserverbannertargetting(context,data) {
                    //  Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                    var formData = new FormData();
                    formData.append('logical',data.targetcode.logical);
                   formData.append('type',data.targetcode.type);
                   formData.append('data',data.targetcode.data);
                   formData.append('comparison',data.targetcode.comparison);
                 // var delievrycode =[];
              
                     if (context.getters.loggedIn) {
    
                      let response = await Vue.axios.post(adserverapiURL+"bnn/"+data.bannerid+"/targeting",formData,
                      { headers: {'Content-Type': 'multipart/form-data' }}).then(response => {
                          console.log(response.data);
                          // resolve(response.data);
                      }).catch(error => {
                     // reject(error);
                     console.log(error)
                      });
                      //this.skills = response
    
                        
                          return  response;
                        }
                      },   
                      videoupload(context,data) {
                        const damntoken =  context.state.token;
                        //  Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                        var formData = data;
                            if (context.getters.loggedIn) {
                              return new Promise((resolve, reject) => {
                                Vue.axios.post(quizstarURL+"uploads3File",formData,{ 
                                  headers: {'Content-Type': 'multipart/form-data',
                                  'Authorization': 'Bearer ' + damntoken  
                                }}).then(response => {
                                    
                                  resolve(response.data);
                                }).catch(error => {
                                reject(error);
                                })
                              })
                            }
                          },  
                          bannerRefund(context, data) {
                            const damntoken =  context.state.token;
                          
                            const postdata = {
                              amount: data.amount,
                              bannerid: data.bannerid,
                              app_type: data.app_type,
                              }; 
                            return new Promise((resolve, reject) => {
                              Vue.axios.post(quizstarURL+'bank/bannerrefund',postdata, {
                                headers: {
                                  'Authorization': 'Bearer ' + damntoken 
                                }
                               }).then(response => {
                                const inbankbalance = response.data.data.balance;
                                const kelsbalance = response.data.data.kels;
                                context.commit('setShowamount',inbankbalance);
                                context.commit('setShowkelamount', kelsbalance);
                                resolve(response.data);
                                //resolve(response);
                              }).catch(error => {
                                reject(error);
                              })
                            })
                          },
                          adserverbannerview(context,data) {
                            //  Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                             if (context.getters.loggedIn) {
                                  return new Promise((resolve, reject) => {
                                    Vue.axios.get(adserverapiURL+"bnn/"+data.bannerid+"/statistics/publisher/"+data.fromdate+"/"+data.todate,
                                    { headers: {'Content-Type': 'multipart/form-data' }}).then(response => {
                                        console.log(response.data);
                                      resolve(response.data);
                                    }).catch(error => {
                                    reject(error);
                                    })
                                  })
                                }
                              },
                              retriveRegions(context){
                                return new Promise((resolve, reject) => {
                                  Api.get('regions').then(response => {
                                    const regions = response.data.data.regions;
                                    context.commit('setRegions', regions);
                                      resolve(response);
                                     
                                  }).catch(error => {
                                    context.commit('setRegions', '');
                                    reject(error);
                                  })
                                })
                             },
                             stateslist(context,data) {
     
                              return new Promise((resolve, reject) => {
                              
                                Api.post('getstateslist', {
                                  countryname: data.countryname,
                                 }).then(response => {
                                  resolve(response.data);
                                  //resolve(response);
                                }).catch(error => {
                                  reject(error);
                                })
                             
                              })
                            }, 
                            citieslist(context,data) {
     
                              return new Promise((resolve, reject) => {
                              
                                Api.post('getcities', {
                                  countryname: data.countryname,
                                  stateid: data.stateid,
                                 }).then(response => {
                                  resolve(response.data);
                                  //resolve(response);
                                }).catch(error => {
                                  reject(error);
                                })
                             
                              })
                            },
                            changepassword(context, data) {
                              Api.defaults.headers.common['Content-Type'] = 'multipart/form-data';
                              return new Promise((resolve, reject) => {
                                Api.post('changepassword',data,{ headers: {'Content-Type': 'multipart/form-data' }}).then(response => {
                                 console.log(response.data.data);
                                 resolve(response);
                                }).catch(error => {
                                  reject(error);
                                })
                              })
                            }, 
                             
}